import translate from "./translation.js";

export default {
  methods: {
    $translate(key) {
      return translate(key);
    },
  },
};
